

class APIService {
  getAccessToken = (): string  => {
    let token: string | null = localStorage.getItem('jsforce0_access_token');
    if (token) {
      token = 'Bearer ' + token;
    } else {
      token = '';
    }
    return token;
  }

  async deleteData(url: string = ''): Promise<Response> {
    return this.fetchData('DELETE', url);
  }

  async putData(url: string = '', data: object = {}): Promise<Response> {
    return this.fetchData('PUT', url, data);
  }
  
  async getData(url: string = ''): Promise<Response> {
    return this.fetchData('GET', url);
  };

  async postData(url: string = '', data: object = {}): Promise<Response> {
    return this.fetchData('POST', url, data);
  };

  async fetchData(method: string, url: string = '', data: object = {}): Promise<Response> {
    let params: any = {
      method: method,
      cache: 'no-cache',
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      headers: (this.getAccessToken() !== '') ? {
        'accept' : 'text/json',
        'Content-Type': 'text/json',
        'Authorization': this.getAccessToken()
      } :
      {
        'accept' : 'text/json',
        'Content-Type': 'text/json',
      }
    };

    if (method.toUpperCase() !== "GET") {
      params.body = JSON.stringify(data);
    }

    const response = await fetch(url, params);
    return response;
  }

  async retrieveRSSFeeds(): Promise<any> {
    // Obtain environment variables
    const env = process.env;
    const newsAndTips = env.REACT_APP_NEWSANDTIPS;
    const rssFeeds = '&ConfigType=rssfeeds';

    //return fetch('/assets/feeds/rss-feeds.json')
    return this.getData(newsAndTips + rssFeeds)
      .then(response => {
        if (!response.ok) {
          this.handleResponseError(response);
        }
        return response.json();
      })
      .catch(error => {
        this.handleError(error);
      });
  }

  async retrieveTips(): Promise<any> {
    // Obtain environment variables and store then in local storage.
    const env = process.env;
    const newsAndTips = env.REACT_APP_NEWSANDTIPS;
    const tips= '&ConfigType=tips';

    //return fetch('/assets/tips/tips.json')
    return this.getData(newsAndTips + tips)
      .then(response => {
        if (!response.ok) {
          this.handleResponseError(response);
        }
        return response.json();
      })
      .catch(error => {
        this.handleError(error);
      });
  }

  handleResponseError(response: any) {
      throw new Error("HTTP error, status = " + response.status);
  }
  handleError(error: any) {
      console.log(error.message);
  }
}
export default APIService;
